import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {NullAsDefault} from 'views/Shared'
import {medal_getMedals_Api} from "../../../../apis";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {bindQueryParams} from "../../functions/routerHelper";
import filterOption from "../../../../helpers/filterOption";
import Pure from "../../../../components/Pure";
import {GoDotFill} from "react-icons/go";

const formSchema = {

    medal_1_id: {
        title: 'medal 1',
        children: [
            {
                name: 'medal_1_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const medals = _.get(form, 'values.medals', []);
                    return (
                        <Translate>
                            {(t) => (
                                <SelectWidget
                                    value={value}
                                    className="w-full"
                                    placeholder={t('click to select')}
                                    showSearch={true}
                                    options={medals.map((e, i) => {

                                        return {label: e.title, value: e.id}
                                    })}
                                    filterOption={filterOption}
                                    onChange={(value, option) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    medal_2_id: {
        title: 'medal 2',
        children: [
            {
                name: 'medal_2_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const medals = _.get(form, 'values.medals', []);
                    return (
                        <Pure input={[value]}>
                            <Translate>
                                {(t) => (
                                    <SelectWidget
                                        value={value}
                                        className="w-full"
                                        placeholder={t('click to select')}
                                        showSearch={true}
                                        disabled={true}
                                        options={medals.map((e, i) => {

                                            return {label: e.title, value: e.id}
                                        })}
                                        filterOption={filterOption}
                                        onChange={(value, option) => {
                                            onChange(createValue(name, value))
                                        }}
                                    />
                                )}
                            </Translate>
                        </Pure>
                    )
                },
            },
        ],
    },
    new_medal_id: {
        title: 'new medal',
        children: [
            {
                name: 'new_medal_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const medals = _.get(form, 'values.medals', []);
                    return (
                        <Pure input={[value]}>
                            <Translate>
                                {(t) => (
                                    <SelectWidget
                                        value={value}
                                        className="w-full"
                                        placeholder={t('click to select')}
                                        showSearch={true}
                                        options={medals.map((e, i) => {

                                            return {label: e.title, value: e.id}
                                        })}
                                        filterOption={filterOption}
                                        onChange={(value, option) => {
                                            onChange(createValue(name, value))
                                        }}
                                    />
                                )}
                            </Translate>
                        </Pure>
                    )
                },
            },
        ],
    },
}

export const CourseMergeMedal = ({
                                     course,
                                     onCancel,
                                     owner_id,
                                     owner_type,
                                     isSubmitting,
                                     onSubmit = NullAsDefault,
                                 }) => {
    const t = useTranslate()

    const {response, isLoading = false} = useAsync({
        apiInfo: medal_getMedals_Api,
        query: bindQueryParams([{prop: owner_type}, {id: owner_id}]),
    })

    const medals = _.get(response, 'data.data', []);

    const validate = (values) => {
        const {medal_1_id, medal_2_id, new_medal_id} = values ?? {}
        let errors = {}

        if (_.isEmpty(medal_1_id)) {
            errors.medal_1_id = t('required field')
        }
        if (_.isEmpty(medal_2_id)) {
            errors.medal_2_id = t('required field')
        }
        if (_.isEmpty(new_medal_id)) {
            errors.new_medal_id = t('required field')
        }
        return errors
    }

    const initialValues = useMemo(() => {
        return {
            owner_id,
            owner_type,
            medal_1_id: undefined,
            medal_2_id: course?.medal?.id,
            new_medal_id: undefined,
            medals
        }
    }, [medals, owner_id, owner_type])

    return !!medals.length && (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                onSubmit(values)
            }}>
            <div className="flex flex-col gap-3">
                <div className="p-2 border-2 border-orange-300 rounded-lg flex flex-col gap-2 italic">
                    <div className="flex flex-col">
                        <span className="font-bold text-xs text-orange-500">
                            {`${t('notes')} : `}
                        </span>
                        <span className="ml-3 text-xs text-color-300">
                            {t('Students who have obtained Certificate 1 (from a different course) and Certificate 2 (from this course) will be awarded an additional certificate, selected from the options below.')}
                        </span>
                    </div>
                    <div className="flex flex-col">
                        <span className="font-bold text-xs text-color-100">
                            {t('example')}
                        </span>
                        <span className="ml-3 text-xs text-color-300">
                            <GoDotFill size={10} className="text-color-400 mr-1" />
                            {t('example merge medal description 1')}
                        </span>
                        <span className="ml-3 text-xs text-color-300">
                            <GoDotFill size={10} className="text-color-400 mr-1" />
                            {t('example merge medal description 2')}
                        </span>
                    </div>
                </div>

                <FieldsFactory
                    formSchema={[
                        formSchema.medal_1_id,
                        formSchema.medal_2_id,
                        formSchema.new_medal_id
                    ]}
                />

                <FormActionGroups
                    isSubmitting={isSubmitting}
                    submitProps={{
                        label: 'merge',
                    }}
                />
            </div>
        </Formik>
    )
}
